import React from 'react';
import { Box } from '@mui/material';
import ChangeBalance from './ChangeBalance';

const ManageBalances: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
      <ChangeBalance title="Decrease User Balance" type="decrease" />
      <ChangeBalance title="Increase User Balance" type="increase" />
    </Box>
  );
};

export default ManageBalances;
